'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./fc-claim-banner.css');

var _FishermanLogoNoText = require('./Fisherman-Logo-NoText.png');

var _FishermanLogoNoText2 = _interopRequireDefault(_FishermanLogoNoText);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ClaimBanner = function (_React$Component) {
  _inherits(ClaimBanner, _React$Component);

  function ClaimBanner() {
    _classCallCheck(this, ClaimBanner);

    var _this = _possibleConstructorReturn(this, (ClaimBanner.__proto__ || Object.getPrototypeOf(ClaimBanner)).call(this));

    _this.state = {
      startedClaim: false,
      completedClaim: false
    };

    _this.onStartClaim = _this.onStartClaim.bind(_this);
    _this.onCompleteClaim = _this.onCompleteClaim.bind(_this);
    return _this;
  }

  _createClass(ClaimBanner, [{
    key: 'onStartClaim',
    value: function onStartClaim() {
      this.setState({ startedClaim: true });
    }
  }, {
    key: 'onCompleteClaim',
    value: function onCompleteClaim(isComplete) {
      if (isComplete) {
        this.setState({ completedClaim: true });
      } else {
        this.setState({ startedClaim: false });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          claimCopy = _props.claimCopy,
          claimButtonCopy = _props.claimButtonCopy,
          onClaimClick = _props.onClaimClick;
      var _state = this.state,
          startedClaim = _state.startedClaim,
          completedClaim = _state.completedClaim;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { id: 'fc-claim-banner-container', style: { display: completedClaim ? 'none' : 'flex' } },
          _react2.default.createElement('img', { src: _FishermanLogoNoText2.default, alt: 'Fisherman Logo' }),
          _react2.default.createElement(
            'div',
            { id: 'fc-claim-banner-content' },
            _react2.default.createElement(
              'div',
              null,
              claimCopy
            ),
            _react2.default.createElement(
              'button',
              { onClick: onClaimClick || this.onStartClaim },
              claimButtonCopy
            )
          )
        ),
        _react2.default.createElement(
          'div',
          null,
          this.props.children({ startedClaim: startedClaim, onCompleteClaim: this.onCompleteClaim })
        )
      );
    }
  }]);

  return ClaimBanner;
}(_react2.default.Component);

exports.default = ClaimBanner;


ClaimBanner.propTypes = {
  claimCopy: _propTypes2.default.string,
  claimButtonCopy: _propTypes2.default.string,
  onClaimClick: _propTypes2.default.func
};

ClaimBanner.defaultProps = {
  claimCopy: 'Make this website yours now!',
  claimButtonCopy: 'Claim Website',
  onClaimClick: null
};